import React, { Fragment, useEffect, useState, useRef } from "react";
import FsLightbox from "fslightbox-react";
import { jwtDecode } from "jwt-decode";
import { Row, Col, Image, Form, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import avatars11 from "../../../assets/images/avatars/01.png";
import avatars1 from "../../../assets/images/avatars/01.png";
import icon1 from "../../../assets/images/icons/01.png";
import icon2 from "../../../assets/images/icons/02.png";
import icon4 from "../../../assets/images/icons/04.png";
import icon8 from "../../../assets/images/icons/08.png";
import icon5 from "../../../assets/images/icons/05.png";
import shap2 from "../../../assets/images/shapes/02.png";
import shap4 from "../../../assets/images/shapes/04.png";
import shap6 from "../../../assets/images/shapes/06.png";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import "react-phone-input-2/lib/style.css";
import InputField from "../../../components/input/input-field";
import TextInput from "../../../components/input/edit-input-field";
import CustomPhoneInput from "../../../components/input/phone-input";
import FadeLoaderComponent from "../../../components/loader-component";
import { roleTypes } from "../../../data/roleType";

const UserProfile = () => {
  const alertRef = useRef(null);
  const alertRefEdit = useRef(null);
  const alertRefPassword = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loader, setLoader] = useState(true);
  const { profileData } = location.state || {};
  const [activeKey, setActiveKey] = useState("first");
  const [toggler, setToggler] = useState();
  const [showAlertSuccessPassword, setShowAlertSuccessPassword] =
    useState(false);
  const [showAlertErrorPassword, setShowAlertErrorPassword] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    if (profileData && profileData.length > 0) {
      setActiveKey(profileData);
    }
  }, [profileData]);

  const [errors, setErrors] = useState({
    currentPassword: [],
    newPassword: [],
    confirmPassword: [],
    name: [],
    address: [],
    phoneNumber: [],
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [decodedToken, setDecodedToken] = useState();
  const [selectedData, setSelectedData] = useState();
  const [selectedPicture, setSelectedPicture] = useState();
  const [token, setToken] = useState(localStorage.getItem("coyote-token"));
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
        const fetchProfileImage = () => {
          setIsLoading(true);
          if (token) {
            setProfileImage(decoded?.user?.profile_picture);
            setSelectedPicture({
              profile_picture: decoded?.user?.profile_picture,
            });
          } else {
            setProfileImage(null);
          }
          setIsLoading(false);
        };
        fetchProfileImage();
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  useEffect(() => {
    setSelectedData({
      name: decodedToken?.name,
      email: decodedToken?.email,
      address: decodedToken?.address,
    });
  }, [decodedToken]);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    const config = {
      headers: {
        Authorization: `${token}`,
      },
    };
    try {
      const response = await axios.put(
        `${url.backendURL}${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/password`,
        {
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        },
        config
      );
      setErrors();
      setShowNewPassword(false);
      setShowCurrentPassword(false);
      setShowConfirmPassword(false);
      setFormData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      resetForm({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      if (alertRefPassword?.current) {
        alertRefPassword.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setAlertMessage(response.data.message);
      setShowAlertSuccessPassword(true);
      setShowAlertErrorPassword(false);
      setTimeout(() => {
        setShowAlertSuccessPassword(false);
      }, 5000);
    } catch (err) {
      if (alertRefPassword?.current) {
        alertRefPassword.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      if (err.response.data.error === "jwt expired" || err.response?.data?.error === "Unauthorized. User not found") {
        localStorage.removeItem("coyote-token");

        navigate(
          `/${
            decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
              ? "admin"
              : "user"
          }/auth/sign-in`,
          {
            state: { status: "expired" },
          }
        );
        setShowAlertSuccessPassword(false);
        setShowAlertErrorPassword(true);
      } else {
        setErrors(err.response.data.error);
        setAlertMessage(
          err.response ? err.response.data.message : "An error occurred"
        );
        setShowAlertSuccessPassword(false);
        setShowAlertErrorPassword(true);
        setTimeout(() => {
          setShowAlertErrorPassword(false);
        }, 5000);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (response?.data?.error === "jwt expired" || response?.data?.error === "Unauthorized. User not found") {
      localStorage.removeItem("coyote-token");

      navigate(
        `/${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/auth/sign-in`,
        {
          state: { status: "expired" },
        }
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    }
  };

  const handleProfileSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (!token) {
        localStorage.removeItem("coyote-token");

        navigate(
          `/${
            decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
              ? "admin"
              : "user"
          }/auth/sign-in`,
          {
            state: { status: "invalid-token" },
          }
        );
        return;
      }
      setSubmitting(true);
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const data = {
        name: values.name,
        phoneNumber: values.phoneNumber,
      };

      // Check if the user is an admin before adding the address
      if (decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)) {
        data.address = values.address;
      }

      const response = await axios.put(
        `${url.backendURL}${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/profile`,
        data,
        config
      );
      setErrors();
      if (alertRefEdit?.current) {
        alertRefEdit.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setAlert({
        message: response && response.data.message,
        type: "success",
        show: true,
        alertFor: "profile",
      });
      localStorage.removeItem("coyote-token");
      localStorage.setItem("coyote-token", response.data.response.jwt);
      setToken(localStorage.getItem("coyote-token"));
      updateProfileHeader(response.data.response.jwt);
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    } catch (err) {
      if (alertRefEdit?.current) {
        alertRefEdit.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "profile");
    } finally {
      setSubmitting(false);
    }
  };

  const handleProfilePictureSubmit = async (
    values,
    { setSubmitting, resetForm }
  ) => {
    try {
      if (!token) {
        localStorage.removeItem("coyote-token");

        navigate(
          `/${
            decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
              ? "admin"
              : "user"
          }/auth/sign-in`,
          {
            state: { status: "invalid-token" },
          }
        );
        return;
      }
      setSubmitting(true);
      const data = new FormData();
      const fileInput = document.getElementById("profilePicture");
      if (values.profilePicture && fileInput && fileInput.files.length > 0) {
        const file = fileInput.files[0];
        data.append("profilePicture", file);
      }
      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.put(
        `${url.backendURL}${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/profile-picture`,
        data,
        config
      );
      setErrors();
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setAlert({
        message: response && response.data.message,
        type: "success",
        show: true,
        alertFor: "picture",
      });

      localStorage.removeItem("coyote-token");
      localStorage.setItem("coyote-token", response.data.response.jwt);
      setToken(localStorage.getItem("coyote-token"));
      updateProfileHeader(response.data.response.jwt);
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
    } catch (err) {
      if (alertRef?.current) {
        alertRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "picture");
    } finally {
      setSubmitting(false);
    }
  };

  const updateProfileHeader = (tokenData) => {
    const profileNameSubHeaderElement = document.getElementById(
      "profileNameSubHeader"
    );
    const profileNameHeaderElement =
      document.getElementById("profileNameHeader");
    const profilePicHeaderElement = document.getElementById("profilePicHeader");
    const { name, profile_picture } = jwtDecode(tokenData).user;
    profileNameSubHeaderElement.innerText = `${name}`;
    profileNameHeaderElement.innerText = `${name}`;

    if (profilePicHeaderElement) {
      profilePicHeaderElement.src = profile_picture
        ? `${profile_picture}`
        : avatars1;
    }
  };

  const [user, setUser] = useState({});
  const getUserProfile = async () => {
    try {
      if (!token) {
        localStorage.removeItem("coyote-token");

        navigate(
          `/${
            decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
              ? "admin"
              : "user"
          }/auth/sign-in`,
          {
            state: { status: "invalid-token" },
          }
        );
        return;
      }

      const config = {
        headers: {
          Authorization: `${token}`,
        },
      };
      const response = await axios.get(
        `${url.backendURL}${
          decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN)
            ? "admin"
            : "user"
        }/`,
        config
      );
      const userData = response.data.response.data;
      setUser({
        name: userData?.name,
        email: userData?.email,
        phoneNumber: userData?.phone_number,
        address: userData?.address,
      });
      setLoader(false);
    } catch (err) {
      if (alertRefEdit?.current) {
        alertRefEdit.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      handleError(err, "profile");
      setLoader(false);
    }
  };

  useEffect(() => {
    if(token && decodedToken){
      getUserProfile();
    }
  }, [decodedToken]);

  const validationSchema = () =>
    Yup.object().shape({
      name: Yup.string()
        .min(1, "Name must be at least 1 character long")
        .max(255, "Name must not exceed 255 characters")
        .trim()
        .matches(
          /^(?=.*[A-Za-z])[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/,
          "Name must start with a letter and can include numbers, spaces, but cannot be entirely numbers"
        )
        .required("Name is required"),
      address: decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) // Only allow address validation if the user is a super admin
        ? Yup.string()
            .min(1, "Address must be at least 1 character long")
            .max(255, "Address must not exceed 255 characters")
            .trim()
            .required("Address is required")
        : Yup.string().notRequired(),
      phoneNumber: Yup.string()
        .trim()
        .matches(/^[0-9+\-]{10,15}$/, "Phone number must be 10 to 15 digits")
        .optional()
        .nullable()
        .test(
          "trim",
          "Phone number may not contain any spaces at the beginning or end",
          (value) => value === (value && value.trim())
        ),
    });

  const validationSchemaProfile = () =>
    Yup.object().shape({
      profilePicture: Yup.mixed()
        .test(
          "fileType",
          "Image must be a valid file (jpeg, png, jpg)",
          (value) =>
            !value ||
            (value &&
              ["image/jpeg", "image/png", "image/jpg"].includes(value.type))
        )
        .required("Profile picture is required"),
    });

  const passwordValidationSchema = Yup.object().shape({
    currentPassword: Yup.string()
      .min(6, "Current password must be at least 6 characters long")
      .max(30, "Current password cannot be longer than 30 characters")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{6,}$/,
        "Current password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      )
      .required("Current password is required"),
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters long")
      .max(30, "Password cannot be longer than 30 characters")
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{6,}$/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      )
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords do not match")
      .required("Confirm password is required"),
  });

  if (isLoading) {
    return <div className="loader"></div>;
  }

  return (
    <Fragment>
      <FsLightbox
        toggler={toggler}
        sources={[
          icon4,
          shap2,
          icon8,
          shap4,
          icon2,
          shap6,
          icon5,
          shap4,
          icon1,
        ]}
      />

      <Row>
        <Col lg="12">
          <Card>
            <Card.Body>
              <div className="d-flex flex-wrap align-items-center justify-content-between">
                <div className="d-flex flex-wrap align-items-center">
                  <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                    <Image
                      className="theme-color-default-img  img-fluid rounded-pill avatar-100"
                      src={profileImage ? profileImage : avatars11}
                      alt="profile-pic"
                    />
                  </div>
                  <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                    <h4 className="me-2 h4 text-capitalize">
                      {decodedToken?.name}
                    </h4>
                    <span className="text-capitalize">
                      {" "}
                      -{" "}
                      {decodedToken?.roles
                        ?.map((role) => role.name)
                        .join(" | ")}
                    </span>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md="5" sm="12" ref={alertRef}>
          <Row className="d-flex align-items-stretch m-0 h-100">
            <Card className="flex-fill d-flex align-items-center justify-content-center">
              <Card.Header>
                <div className="header-title">
                  <h4 className="card-title">Profile Picture</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <Formik
                  initialValues={{
                    selectedPicture,
                    profilePicture: null,
                  }}
                  validationSchema={validationSchemaProfile}
                  onSubmit={handleProfilePictureSubmit}
                  enableReinitialize
                >
                  {({
                    values,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting,
                    touched,
                  }) => (
                    <Form
                      className="form-horizontal h-100 d-flex flex-column justify-content-between"
                      onSubmit={handleSubmit}
                    >
                      {alert.alertFor === "picture" && (
                        <AlertNotificationSimple
                          type={alert.type}
                          message={alert.message}
                          show={alert.show}
                          onClose={() => setAlert({ ...alert, show: false })}
                        />
                      )}
                      <FocusError />
                      <Form.Group className="d-flex flex-column align-items-center justify-content-center">
                        <div className="profile-img-edit position-relative">
                          <Image
                            className="theme-color-default-img profile-pic rounded avatar-100"
                            src={
                              previewImage
                                ? previewImage
                                : selectedPicture?.profile_picture
                                ? `${selectedPicture.profile_picture}`
                                : avatars1
                            }
                            alt="profile-pic"
                          />

                          {values.profilePicture && (
                            <button
                              type="button"
                              className="btn btn-sm btn-danger position-absolute rounded-circle p-1"
                              style={{
                                top: "-8px",
                                right: "-8px",
                                width: "24px",
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 10,
                              }}
                              onClick={() => {
                                if (previewImage) {
                                  URL.revokeObjectURL(previewImage);
                                  setPreviewImage(null);
                                }

                                setFieldValue("profilePicture", null);

                                const fileInput =
                                  document.getElementById("profilePicture");
                                if (fileInput) {
                                  fileInput.value = "";
                                }
                              }}
                              title="Remove selected image"
                            >
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  stroke="white"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M18 6L6 18M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}

                          <div
                            className="upload-icone bg-primary"
                            onClick={() =>
                              document.getElementById("profilePicture").click()
                            }
                          >
                            <svg
                              className="upload-button"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="#ffffff"
                                d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z"
                              />
                            </svg>
                            <Form.Control
                              className="file-upload"
                              id="profilePicture"
                              type="file"
                              accept=".png, .jpg, .jpeg"
                              name="profilePicture"
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                if (file) {
                                  // Clear previous preview
                                  if (previewImage) {
                                    URL.revokeObjectURL(previewImage);
                                  }
                                  // Create new preview
                                  const newPreviewUrl =
                                    URL.createObjectURL(file);
                                  setPreviewImage(newPreviewUrl);
                                  setFieldValue("profilePicture", file);
                                } else {
                                  setPreviewImage(null);
                                  setFieldValue("profilePicture", null);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="img-extension mt-3">
                          <div className="d-inline-block align-items-center">
                            <span>Only</span> <Link to="#">.jpg</Link>{" "}
                            <Link to="#">.png</Link> <Link to="#">.jpeg</Link>{" "}
                            <span>allowed</span>
                          </div>
                        </div>
                        <ErrorMessage
                          name="profilePicture"
                          component="div"
                          className="text-danger"
                        />
                        {Array.isArray(errors?.profilePicture) &&
                          errors.profilePicture.map((error, index) => (
                            <span
                              key={index}
                              className="w-100 mt-1 small text-danger"
                            >
                              {error}
                              <br />
                            </span>
                          ))}
                      </Form.Group>
                      <Form.Group
                        className="form-group d-flex justify-content-center"
                        style={{ marginTop: "2rem" }}
                      >
                        <Button
                          type="submit"
                          variant="btn btn-primary"
                          className="ms-2"
                          disabled={isSubmitting || !values.profilePicture}
                        >
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </Button>
                      </Form.Group>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Row>
        </Col>

        <Col md="7" sm="12" className="d-flex">
          <Card className="flex-fill">
            <Card.Header>
              <div className="header-title w-100" ref={alertRefPassword}>
                <h4 className="card-title">Update Password</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  ...formData,
                }}
                validationSchema={passwordValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form>
                    <AlertNotificationSimple
                      type="success"
                      message={alertMessage}
                      show={showAlertSuccessPassword}
                      onClose={() => setShowAlertSuccessPassword(false)}
                    />
                    <AlertNotificationSimple
                      type="danger"
                      message={alertMessage}
                      show={showAlertErrorPassword}
                      onClose={() => setShowAlertErrorPassword(false)}
                    />
                    <FocusError />
                    <Row>
                      <Col lg="12" className="col-lg-12">
                        <InputField
                          className="floating-label"
                          type="password"
                          name="currentPassword"
                          placeholder="***********"
                          value={values.currentPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          showPasswordToggle={true}
                          showPassword={showCurrentPassword}
                          setShowPassword={setShowCurrentPassword}
                          asterick={true}
                          errorMessage={errors?.currentPassword}
                          label="Current Password"
                        />

                        <InputField
                          className="floating-label"
                          type="password"
                          name="newPassword"
                          placeholder="***********"
                          value={values.newPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          showPasswordToggle={true}
                          showPassword={showNewPassword}
                          setShowPassword={setShowNewPassword}
                          asterick={true}
                          errorMessage={errors?.newPassword}
                          label="New Password"
                        />
                        <InputField
                          className="floating-label"
                          type="password"
                          name="confirmPassword"
                          placeholder="***********"
                          value={values.confirmPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          showPasswordToggle={true}
                          showPassword={showConfirmPassword}
                          setShowPassword={setShowConfirmPassword}
                          asterick={true}
                          errorMessage={errors?.confirmPassword}
                          label="Confirm Password"
                        />
                      </Col>
                    </Row>
                    <Form.Group className="form-group d-flex justify-content-end">
                      <Button
                        disabled={isSubmitting}
                        className="mt-3 align-items-right"
                        type="button"
                        variant="primary"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    </Form.Group>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md="12" sm="12">
          <Card>
            <Card.Header>
              <div className="header-title" ref={alertRefEdit}>
                <h4 className="card-title">Update Profile</h4>
              </div>
            </Card.Header>
            <Card.Body>
              {alert.alertFor === "profile" && (
                <AlertNotificationSimple
                  type={alert.type}
                  message={alert.message}
                  show={alert.show}
                  onClose={() => setAlert({ ...alert, show: false })}
                />
              )}
              <Formik
                initialValues={{
                  ...user,
                }}
                validationSchema={validationSchema}
                onSubmit={handleProfileSubmit}
                enableReinitialize
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  isSubmitting,
                  touched,
                }) =>
                  user && !loader ? (
                    <Form className="form-horizontal" onSubmit={handleSubmit}>
                      <FocusError />
                      <Row>
                        <Col md="6" sm="12">
                          <TextInput
                            label="Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={true}
                            errors={errors?.name}
                          />
                        </Col>
                        <Col md="6" sm="12">
                          <TextInput
                            label="Email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required={true}
                            errors={errors?.email}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {decodedToken?.roles?.some(
                          (role) => role.role_type === roleTypes.SUPER_ADMIN
                        ) && (
                          <Col md="6" sm="12">
                            <TextInput
                              label="Address"
                              name="address"
                              value={values?.address}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              required={true}
                              errors={errors?.address}
                            />
                          </Col>
                        )}
                        <Col md="6" sm="12">
                          <Form.Group as={Row} className="form-group">
                            <Form.Label
                              column
                              sm="4"
                              className="control-label  align-self-center mb-0"
                              htmlFor="phoneNumber"
                            >
                              Phone Number
                            </Form.Label>
                            <Col sm="8">
                              <CustomPhoneInput
                                id="phoneNumber"
                                name="phoneNumber"
                                value={values.phoneNumber}
                                onChange={(value) =>
                                  setFieldValue("phoneNumber", value)
                                }
                                onBlur={handleBlur}
                                placeholder="Enter phone number"
                                country="us"
                                isValid={(value, country) => {
                                  if (value.match(/12345/)) {
                                    return `Invalid value: ${value}, ${country.name}`;
                                  } else if (value.match(/1234/)) {
                                    return false;
                                  } else {
                                    return true;
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="phoneNumber"
                                component="div"
                                className="text-danger"
                              />
                              {Array.isArray(errors?.phoneNumber) &&
                                errors.phoneNumber.map((error, index) => (
                                  <span
                                    key={index}
                                    className="w-100 mt-1 small text-danger"
                                  >
                                    {error}
                                    <br />
                                  </span>
                                ))}
                            </Col>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="form-group d-flex justify-content-end">
                        <Button
                          type="submit"
                          variant="btn btn-primary"
                          className="ms-2"
                          disabled={isSubmitting}
                        >
                          Submit
                        </Button>
                      </Form.Group>
                    </Form>
                  ) : (
                    loader && <FadeLoaderComponent />
                  )
                }
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default UserProfile;
